import Classes from './Sidebar.module.css';
import {  motion } from "framer-motion"
 import Linkdin from '../../assest/linkedin.png';
 import Instagram from '../../assest/instagram.png';
 import Hackerrank from '../../assest/Hackerrank.png';
import Stop1 from '../../assest/stopstalk.png';
 import Codechef from '../../assest/codechef.png';
 import Codeforces from '../../assest/codeforces.png';
 import GeeksforGeeks from '../../assest/geeksforgeeks.png';
 import Github from '../../assest/github.png';
 import Facebook from '../../assest/facebook .png';
import Profile from '../../assest/Profile.jpg';
import Resume from '../../assest/resume.png';
import Location from '../../assest/pin.svg';
import Email from '../../assest/email.svg';
import Mobile from '../../assest/mobile.svg';
import Sms from '../../assest/sms.svg';
import Resume_1 from '../../assest/resume/resume_avi.pdf';
import Typical from 'react-typical'
import classes from './Sidebar.module.css';
import Particles from "react-tsparticles";


function sidebar() {
    const mailme = ()=>{
        window.open("mailto:avikr407@gmail.com");
    
    }
    const con = [classes.contact];
    const con1 = [classes.social_profile];
    const cont2= ["btn btn-dark btn-block",classes.color1 ];
    const ani = {
        hidden:{
            x:'-30vh',
            opacity:0
        },
        visible:{
            x:0,
            opacity:1,
            transition:{
                delay:0.7,duration:0.7,type:'spring'
            }
            

        }
    }
    return (
        <motion.div  style= {{position:"relative"}}
        variants={ani}
        initial='hidden'
        animate='visible'
        >
            
            <div className={Classes.center1} >  <img src={Profile} alt="portfolio" className={Classes.image} /></div>

           
            <div className={classes.center1}> <Typical
        steps={['AVI SRIVASTAVA', 5000, 'AStream26', 5000]}
        loop={Infinity}
        wrapper="h6"
      /></div>
            <div className={classes.center}>
                
                <Typical  className={classes.center1}
        steps={['MERN STACK', 3000, 'Competitive', 500,'Programming',1000]}
        loop={Infinity}
        wrapper="h5"
      />
           
            </div>
            
          
                <div style={{marginBottom:"2.5em"}} >

                    
                   <a href={Resume_1} download="resume.pdf" className={cont2.join(' ')}> <img src={Resume} alt="resume" className={Classes.socialicon} />RESUME</a>
                    
                </div>
           
            <div>
            <div className={con1.join(' ')}>
            <a href="https://www.stopstalk.com/user/profile/Astream26"><img src={Stop1} alt="Github" className={Classes.socialicon} /></a>
                <a href="https://www.linkedin.com/in/avi-kumar-srivastava-79a25b177/"><img src={Linkdin} alt="Linkdin" className={Classes.socialicon} /></a>
                <a href="https://www.facebook.com/avi.srivastava.188478/"><img src={Facebook} alt="Facebook" className={Classes.socialicon} /></a>
                <a href="https://www.instagram.com/sri.avi26/"><img src={Instagram} alt="instagram" className={Classes.socialicon} /></a>
                
            </div>
            <div className={con1.join(' ')}>
                <a href="https://www.hackerrank.com/AStream26"><img src={Hackerrank} alt="Hackerrank" className={Classes.socialicon} /></a>
                <a href="https://www.codechef.com/users/galaxy26"><img src={Codechef} alt="Codechef" className={Classes.socialicon} /></a>
                <a href="https://codeforces.com/profile/avi2601"><img src={Codeforces} alt="Codeforces" className={Classes.socialicon} /></a>
                <a href="https://auth.geeksforgeeks.org/user/astream26/profile"><img src={GeeksforGeeks} alt="GeeksforGeeks" className={Classes.socialicon} /></a>

            </div>
            </div>
            <div className={con.join(' ')}>
            <div className="item">
            
            <p > <a className={cont2.join(' ')} href="http://github.com/Astream26"><img src={Github} alt="Git" className={Classes.contacticon} />Github</a></p>
         </div>
            <div className="item">
            
                   <p className={cont2.join(' ')}> <a href='###/'><img src={Location} alt="Address" className={Classes.contacticon} /></a>Jaunpur,India</p>
                </div>
            
                <div className="item">
                   <p className={cont2.join(' ')}> <a href='/###'><img src={Email} alt="gmail" className={Classes.contacticon} /></a>avikr407 @gmail.com</p>
                </div>
                <div className="item">
                   <p ><a href="tel:+918957019974" className={cont2.join(' ')}><img src={Mobile} alt="number" className={Classes.contacticon} />8957019974</a></p>
                </div>
                <div className="email" onClick={mailme}>
                <p className={cont2.join(' ')}><a href="/###"><img src={Sms} alt="mobile" className={Classes.contacticon} /></a>Contact Me</p>
            </div>

            </div>

           

        </motion.div>
    );
}

export default sidebar;